export default __webpack_public_path__ + "static/youtube-86077a9fac17e7ba3c57ee4da48851f5.svg";